import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import Menu from 'react-burger-menu/lib/menus/slide'
import config from '../../config'
import {
  Link,
  LinkIcon,
} from '../../components'
import Styles from './IyvListMobileTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListMobileSort extends Component {
  static propTypes = {
    sort: PropTypes.string,
    isDesc: PropTypes.bool,
    clickColumnHeader: PropTypes.func,
    resultsTableColumns: PropTypes.object,

  }
  //
  constructor(props) {
    super(props)
    this.state = {
      sort: props.sort,
      isDesc: props.isDesc,
      menuOpen: false,
      resultsShow: true,
      performanceShow: false,
      iyvShow: false,
      labels: {
        'results': {
          'Fossil Free Funds': 'Fossil fuels',
          'Deforestation Free Funds': 'Deforestation',
          'Gender Equality Funds': 'Gender equality',
          'Gun Free Funds': 'Civilian firearms',
          'Prison Free Funds': 'Prison industrial complex',
          'Weapon Free Funds': 'Military weapons',
          'Tobacco Free Funds': 'Tobacco',
          'Invest Your Values': 'Sustainability'
        },
        'performance': 'Financial performance',
        'iyv': 'Sustainability'
      }
    }
  }
  //
  componentWillReceiveProps(props){
    this.setState({
      sort: props.sort,
      isDesc: props.isDesc,
    })
  }
  //
  renderBurger = (isDesc) => {
    return <div>
      <div style={{
        fontSize: '0.875rem',
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%'
      }}>
        <div style={{
          fontWeight: 800,
        }}>
          SORT
        </div>
        <div>
          <LinkIcon faclass={
            isDesc ? 'fa-caret-down' : 'fa-caret-up'
          }/>
        </div>
      </div>
    </div>
  }
  //
  clickSortPanelButton = (v) => {
    const newState = {
      menuOpen: true,
      resultsShow: false,
      performanceShow: false,
      iyvShow: false,
    }
    // if requested panel already showing, close them all
    if (!this.state[v+'Show']) {
      newState[v+'Show'] = true
    }
    this.setState(newState)
  }
  //
  render() {
    const styles = {
      bmBurgerButton: {
        position: 'relative',
        // width: '1.25rem',
        // height: '1.1rem',
        // float: 'right',
        float: 'left',
        cursor: 'pointer'
      },
      bmBurgerBars: {
        background: '#333',
        cursor: 'pointer'
      },
      bmIcon: {
        whiteSpace: 'nowrap',
        fontSize: '1.5em',
        fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      bmMenuWrap: {
        top: 0,
        zIndex: 10001,
        width: '100%',
        maxWidth: '100%',
        left: '0px'
      },
      bmCrossButton: {
        height: '1.6rem',
        width: '1.6rem',
        cursor: 'pointer'
      },
      bmCross: {
        background: '#333',
        cursor: 'pointer'
      },
      bmMenu: {
        background: 'white',
        padding: '0 2.5rem 0 0',
        fontSize: '1.15rem',
        borderLeft: '1px solid #A3A3A3'
      },
      bmMorphShape: {
        fill: 'white'
      },
      bmItemList: {
        color: '#333',
        padding: '0 1rem 1rem 1rem',
        boxSizing: 'border-box'
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.76)',
        top: 0,
        right: 0,
        zIndex: 10000,
      }
    }

    return <div styleName='ilmt-sort'>
      <Menu
        styles={styles}
        isOpen={this.state.menuOpen}
        burgerButtonClassName=''
        disableOverlayClick
        customBurgerIcon={ this.renderBurger(this.props.isDesc) }
      >
        <nav>
          <h2>
            Sort by
          </h2>
          {
            Object.keys(this.props.resultsTableColumns[config.app.title]).map((e, i) => {
              const rows = this.props.resultsTableColumns[config.app.title][e]
              // skip first row if not first viewPanel.
              // to avoid showing fund name 3 times
              let _rows = rows
              if (e === 'performance') {
                _rows = rows.slice(1, rows.length - 1)
              } else if (e === 'iyv') {
                _rows = rows.slice(1, rows.length)
              }

              return <div key={`mobile-sort-${i}`}>
                <button
                  styleName='ilmt-item-switch'
                  onClick={() => { this.clickSortPanelButton(e) }}
                >
                  {
                    e === 'results' ?
                      this.state.labels[e][config.app.title] :
                      this.state.labels[e]
                  }
                  <LinkIcon nospace faclass={
                    this.state[`${e}Show`] ?
                      'fa-angle-up' :
                      'fa-angle-down'
                  }/>
                </button>
                <SlideDown>
                  {
                    this.state[`${e}Show`] ?
                      _rows.map((_e, _i) => {
                        const name = _e[0]
                        const fieldName = _e[1]
                        return <button
                          styleName={'ilmt-item ' + (this.state.sort === fieldName ? 'ilmt-item-active' : '')}
                          key={`mobile-sort-${i}-${_i}`}
                          onClick={() => {
                            this.setState({
                              menuOpen: true,
                              sort: fieldName
                            })
                          }}
                        >
                          {name}
                        </button>
                      }) :
                      null
                  }
                </SlideDown>
              </div>
            })
          }
        </nav>

        <div styleName='ilmt-apply-ascending-buttons'>
          <button
            styleName='ilmt-apply-button'
            onClick={()=>{
              this.props.clickColumnHeader(this.state.sort, (this.state.isDesc ? 'desc' : 'asc'))()
            }}
          >
            Apply
          </button>

          <button
            styleName='ilmt-ascending-button'
            onClick={()=>{
              this.setState({
                menuOpen: true,
                isDesc: !this.state.isDesc,
              })
            }}
          >
            {
              this.state.isDesc ?
                'Descending' :
                'Ascending'
            }
            <LinkIcon faclass={
              this.state.isDesc ?
                'fa-caret-down' : 
                'fa-caret-up' 
            }/>
          </button>

        </div>
      </Menu>
      { /* <div>
        <LinkIcon faclass='fa-caret-down' nospace/>
      </div> */ }
    </div>
  }
}
